import { css } from "../../../../styled-system/css";

export const styles = {
  loadingTxt: () =>
    css({
      color: "paleBlue",
      fontWeight: "normal",
    }),
  loadingWrap: (stretchContainer: boolean) =>
    css({
      display: "flex",
      flexDirection: "column",
      justifyItems: "center",
      alignItems: "center",
      minHeight: stretchContainer ? "100vh" : "unset",
    }),
};
